import React from 'react'
import styled from '@emotion/styled'

import { colors } from 'Constants'

import { Flex, Image } from 'lese'
import Link, { NavbarLink } from 'Components/shared/Link'

const NavbarContainer = styled(Flex)`
  padding: 0 8px;
  background-color: ${colors.background800};
  border-bottom: 1px solid ${colors.borderColor};
  min-height: 60px;
`

export default () => {
  return (
    <NavbarContainer xAlign="space-between" yAlign>
      <Flex separation="24px" yAlign>
        <Link to="/">
          <Image src="/logo.png" />
        </Link>
      </Flex>

      <Flex separation="24px" yAlign>
        <NavbarLink to="/logout">Logout</NavbarLink>
      </Flex>
    </NavbarContainer>
  )
}
